import type {SendFn} from '../setupMessages';

const loadHumanSecurityJs = async (
  appId: string,
  sendMessage?: SendFn<'HumanSecurity'>,
  retries = 2,
  timeout = 2000,
): Promise<void> => {
  function createScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://client.px-cloud.net/${appId}/main.min.js`;
      script.async = true;

      const timeoutId = setTimeout(() => {
        reject(new Error(`Timeout loading script for ${appId}`));
      }, timeout);

      script.onerror = () => {
        clearTimeout(timeoutId);
        reject(new Error(`Failed to load script for ${appId}`));
      };

      script.onload = () => {
        clearTimeout(timeoutId);
        resolve();
      };

      if (!document.head) {
        throw new Error('Unexpectedly missing <head>.');
      }

      document.head.appendChild(script);
    });
  }

  const attemptLoad = (attemptsLeft: number): Promise<void> => {
    return createScript().catch((error: Error) => {
      sendMessage?.({
        type: 'event',
        name: 'human-security-load-timeout',
        data: {retries: retries - attemptsLeft, error: error.message},
      });

      if (attemptsLeft > 0) {
        return attemptLoad(attemptsLeft - 1);
      } else {
        throw error;
      }
    });
  };

  return attemptLoad(retries);
};

export default loadHumanSecurityJs;
